type FilterChipsProps<T extends string> = {
  options: readonly T[];
  value: T;
  onChange: (next: T) => void;
  /** Visible text for an option; options are stable ids, so translate here. */
  getLabel: (option: T) => string;
};

export function FilterChips<T extends string>({
  options,
  value,
  onChange,
  getLabel,
}: FilterChipsProps<T>) {
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={[
              'shrink-0 rounded-lg border px-3.5 py-2 text-[13.5px] font-semibold transition',
              active
                ? 'border-signal bg-panel2 text-ink'
                : 'border-line bg-transparent text-muted hover:text-ink',
            ].join(' ')}
          >
            {getLabel(option)}
          </button>
        );
      })}
    </div>
  );
}
